import React from "react";
import "./Deposite_History.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Deposite_History_card from "./Deposite_History_card/Deposite_History_card";
import No_data from "../../Common/No_data/No_data";

function Deposite_History() {
  const navigate = useNavigate();
  return (
    <section className="Withdrawal_History">
      <div className="withdrawal_header History_header">
        <div className="header-left">
          <span className="header_icon">
            <FontAwesomeIcon icon={faFileLines} />
          </span>
          <h4>Deposit History</h4>
        </div>
      </div>

      <Deposite_History_card status="Failed" badge="Deposite" />
      <No_data/>

      <div className="text-center">
        <Button
          className="btn-register mb-3"
          onClick={() => navigate("/deposite-history")}
        >
          All History
        </Button>
      </div>
    </section>
  );
}

export default Deposite_History;
